@if (loading) {
  <div class="impersonate-container">
    <div class="spinner"></div>
  </div>
}
